class Breakpoints {
  breakpoints = {
    sm: 480,
    md: 769,
    lg: 1066
  }
  up(breakpoint = 'md') {
    return window.matchMedia(`all and (min-width: ${this.breakpoints[breakpoint]}px)`);
  }
  down(breakpoint = 'md') {
    return window.matchMedia(`not all and (min-width: ${this.breakpoints[breakpoint]}px)`);
  }
  between(breakpointMin = 'md', breakpointMax = 'lg') {
    return window.matchMedia(`all and (min-width: ${this.breakpoints[breakpointMin]}px) and (not (min-width: ${this.breakpoints[breakpointMax]}px))`);
  }
}
export default Breakpoints;

// // 例
// // インスタンス化
// const breakpoints = new Breakpoints();
// // ブレイクポイントを指定
// const isDesktop = this.breakpoints.up('lg');

// // ロード後の処理
// if (isDesktop.matches) {
//   // ここに処理を書く
// }

// // リサイズ後の処理
// isDesktop.addEventListener('change', fn.bind(this));
// const fn = (e) => {
//   if (e.matches) {
//     // ここに処理を書く
//   }
// }